// extracted by mini-css-extract-plugin
export default {"root":"styles_root__G7Bnz","unverified":"styles_unverified__xSDYO","verified":"styles_verified__o2iDt"};